module.exports = __webpack_public_path__ + "static/img/Personalizados.9a5cc291.png";